// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"524a2610","633":"a8258686"}[chunkId] + ".chunk.js";
};